import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.option = {
      mt: 0,
      pb: 6,
      width: '100%',
      borderBottom: (t) => `1px solid ${t.colors.gray}`,
    };

    this.header = {
      variant: 'flex.row.start.center',
      mt: 8,
      mb: 5,
    };

    this.name = {
      variant: 'text.label.1',
      mr: 4,
    };

    this.color = {
      color: 'mediumDarkGray',
    };

    this.values = (totalSquares) => ({
      display: 'grid',
      pl: 0,
      mr: 'auto',
      gap: 6,
      gridTemplateColumns: `repeat(${totalSquares}, calc((${
        1 / totalSquares
      } * 100%) - (${totalSquares - 1} * 12px / ${totalSquares})))`,
      width: '100%',
      maxWidth: `${64 * totalSquares + (totalSquares - 1) * 12}px`,
    });

    this.colorOptionWrapper = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    };

    this.value = {
      p: 4,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      fontSize: '12px',
      width: '100%',
      borderRadius: '4px',
      position: 'relative',
      transition: 'all 0.15s ease-in-out',
      ':hover': {
        color: 'mediumDarkGray',
        border: (t) => `1px solid ${t.colors.mediumDarkGray}`,
        '[data-comp="Picture"]': {
          opacity: 1,
        },
      },

      available: {
        selected: {
          border: (t) => `1px solid ${t.colors.text}`,
          bg: 'background',
          color: 'text',
        },
        unselected: {
          border: (t) => `1px solid ${t.colors.gray}`,
          bg: 'background',
          color: 'text',
        },
      },
      unavailable: {
        selected: {
          border: (t) => `1px solid ${t.colors.text}`,
          bg: 'background',
          color: 'text',
        },
        unselected: {
          border: (t) => `1px solid ${t.colors.gray}`,
          bg: 'background',
          color: 'gray',
        },
      },
    };

    this.colorName = {
      fontSize: ['12px', '9px'],
      lineHeight: ['14px', '11px'],
      textAlign: 'center',
      mt: 2,
      color: 'text',
      fontWeight: 'normal',
      width: '100%',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      wordBreak: 'normal',
      overflowWrap: 'break-word',
      hyphens: 'auto',
    };

    this.seeAllWrapper = {
      position: 'relative',
      pb: '100%',
    };

    this.seeAll = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '4px',
      mb: 6,
      p: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      border: (t) => `1px solid ${t.colors.gray}`,
      bg: 'background',
      color: 'text',
      transition: 'all 0.15s ease-in-out',
      ':hover': {
        border: (t) => `1px solid ${t.colors.mediumDarkGray}`,
      },

      icon: {
        width: '20px',
        color: 'text',
      },

      text: {
        fontSize: '10px',
        lineHeight: '12px',
      },
    };

    this.tabs = {
      display: 'flex',
      gap: [10, 0],
      justifyContent: ['space-between', 'flex-start'],
      mt: 8,
      mb: [6, 4],
      borderBottom: (t) => `1px solid ${t.colors.gray}`,
    };

    this.tab = {
      px: 0,
      py: 4,
      mr: [0, 8],
      bg: 'transparent',
      border: 'none',
      borderBottom: '2px solid transparent',
      color: 'mediumDarkGray',
      fontSize: ['16px', '14px'],
      fontWeight: ['400', '450'],
      cursor: 'pointer',
      transition: 'all 0.15s ease-in-out',
      ':hover': {
        color: 'text',
      },

      active: {
        color: 'text',
        borderBottomColor: 'text',
        fontWeight: '500',
      },
    };

    this.colorGrid = {
      display: 'grid',
      pl: 0,
      gap: [7, 6],
      gridTemplateColumns: [
        'repeat(auto-fill, minmax(75px, 1fr))',
        'repeat(auto-fill, minmax(54px, 1fr))',
      ],
      width: '100%',
      maxWidth: '100%',
    };
  })()
);
